import React, {useContext} from "react";
import {RecordsManagementContext} from "../StatesMangement/InitialiseContext";
import {Modal} from "react-bootstrap";
import InvoicePaymentForm from "../ClientPortal/InvoicePaymentForm";
import TipModal from "../ClientPortal/TipModal";

export default () => {
    let Record = useContext(RecordsManagementContext)
    let ClientPortalHeader = Record.CP_PageDetails.ClientPortalHeader
    let InvoicePayment = ClientPortalHeader.InvoicePayment
    const hideInvoicePaymentModal = () => {
        Record.setInvoicePaymentModal(false) //close pay deposit modal
    }

    const Button = (props) => {
        if (props.Show) {
            return (
                <div className={props.ClsName}
                     onClick={() => showTipModal()}>
                    <b>{props.For}</b>
                </div>
            )
        } else {
            return (<></>)
        }
    }

    const showTipModal = () => {
        if (tipAmount()) {
            Record.setCrewTipModal(true)
            Record.setTipforCrew(false)
        } else {
            Record.setInvoicePaymentModal(true)
        }

    }

    const tipAmount = () => {
        let iv3Tip = undefined
        if (Record.IV3_PageDetails && Record.IV3_PageDetails.JobDetails && Record.IV3_PageDetails.JobDetails.Tip) {
            iv3Tip = Record.IV3_PageDetails.JobDetails.Tip.Value
        }
        if (iv3Tip !== undefined) {
            return iv3Tip <= 0 && Record.Tip == '' && ClientPortalHeader.InvoicePayment.IsBilledJob
        }

        let iv2Tip = undefined
        if (Record.IV2_PageDetails && Record.IV2_PageDetails.JobDetails && Record.IV2_PageDetails.JobDetails.Tip) {
            iv2Tip = Record.IV2_PageDetails.JobDetails.Tip.Value
        }
        if (iv2Tip !== undefined) {
            return iv2Tip <= 0 && Record.Tip == '' && ClientPortalHeader.InvoicePayment.IsBilledJob
        }

        let iv1Tip = Record.IV1_PageDetails ? Record.IV1_PageDetails.Tip : undefined
        if (iv1Tip !== undefined) {
            return iv1Tip <= 0 && Record.Tip == '' && ClientPortalHeader.InvoicePayment.IsBilledJob
        }

        return false
    }

    return (
        <>
            <Button
                ClsName="btn btn-dark btn-sm"
                Show={(((InvoicePayment.EnableInvoicePayment && InvoicePayment.IsBolSubmited) ||
                    InvoicePayment.IsBilledJob) && InvoicePayment.DueBalance > 0 && InvoicePayment.HasPaymentGateway)}
                For='PAY MY INVOICE'/>
            <Modal show={Record.InvoicePaymentModal} onHide={() => hideInvoicePaymentModal()}
                   style={{top: "9%"}}
            >
                <Modal.Header><h5 style={{color: "#37abdb", fontSize: "15px", fontWeight: 600}}>
                    Invoice Payment </h5>
                    <button onClick={() => hideInvoicePaymentModal()}
                            style={{color: "red", background: "white", border: "white", height: "5%"}}>
                        <b className="contactInfoCloseBtn">X</b></button>
                </Modal.Header>
                <Modal.Body style={{minHeight: 545, maxHeight: 700, overflowY: "scroll"}}>
                    <InvoicePaymentForm  FormatVisible={Record.FormatVisible} Tip={Record.Tip}/>
                </Modal.Body>
            </Modal>

            <TipModal/>
        </>

    )
}
